import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

export const Label = styled(Box).attrs({
  font: 'metadata-semibold-asphalt',
  fontSize: 1,
  mr: 1,
  as: 'span',
  display: 'inline',
})``;

export const Value = styled(Box).attrs({
  font: 'metadata-regular-asphalt',
  fontSize: 1,
  mr: 1,
  as: 'span',
  display: 'inline',
})``;
